import { MuiTableRow, styled } from '../../../base-components';
import { shouldForwardProp } from '@mui/system';

const customShouldForwardProp = (prop: PropertyKey) =>
    shouldForwardProp(prop) &&
    !['isSelected', 'isRowClickable', 'isReadOnly'].includes(prop as string);

export const StyledTableRow = styled(MuiTableRow, {
    shouldForwardProp: customShouldForwardProp,
})<{
    isSelected?: boolean;
    isRowClickable: boolean;
    isReadOnly: boolean;
}>(({ theme, isSelected, isRowClickable, isReadOnly }) => ({
    height: 56,
    position: 'relative',

    // ...(isSelected && {
    //     borderLeft: `3px solid ${theme.palette.primary.main}`,
    // }),

    cursor: isRowClickable && !isReadOnly ? 'pointer' : 'auto',
    // height: '40px',

    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.common.white,
    },
    '&:nth-of-type(even)': {
        backgroundColor: theme.palette.grey[200],
    },

    '&:hover': {
        outline: `1px solid ${theme.palette.primary.main}`,
        outlineOffset: '-2px',
        zIndex: 2,
    },

    '& > td': {
        zIndex: 1,
        position: 'relative',
    },
}));
